import dayjs from 'dayjs';
import 'dayjs/locale/tr';
dayjs.locale('tr');

export const tarotReadingCards = [
  {
    title: 'Günlük Tarot Falı',
    image: '/images/tarot/reading-gunluk-fali.png',
    imageClass: '-bottom-8 -right-4 w-[150px] h-auto',
    url: '/tarot/gunluk-tarot-fali',
  },
  {
    title: 'Aşk Tarot Falı',
    image: '/images/tarot/reading-ask-fali.png',
    imageClass: 'h-[124px] -bottom-2 right-0',
    url: '/tarot/ask-tarot-fali',
  },
  {
    title: 'Sağlık Tarot Falı',
    image: '/images/tarot/reading-saglik-fali.png',
    imageClass: '-bottom-16 right-0 w-[150px] h-auto',
    url: '/tarot/sağlık-tarot-fali',
  },
  {
    title: 'Para Tarot Falı',
    image: '/images/tarot/reading-para-fali.png',
    imageClass: 'h-[124px] -bottom-5 right-0',
    url: '/tarot/para-tarot-fali',
  },
  {
    title: 'Evet/Hayır Tarot Falı',
    image: '/images/tarot/reading-evet-hayir-fali.png',
    imageClass: 'h-[124px] -bottom-5 right-0',
    url: '/tarot/evet-hayir-tarot-fali',
  },
  {
    title: 'Flört Tarot Falı',
    image: '/images/tarot/reading-flort-fali.png',
    imageClass: 'h-[124px] -bottom-5 right-0',
    url: '/tarot/flort-tarot-fali',
  },
  {
    title: 'Potansiyel Aşk Tarot Falı',
    image: '/images/tarot/reading-potansiyel-ask-fali.png',
    imageClass: 'h-[124px] -bottom-5 right-0',
    url: '/tarot/potansiyel-ask-tarot-fali',
  },
];

export const tarotMoreInfoCards = [
  {
    title: 'Tarot Nedir?',
    image: '/images/tarot/tarot-nedir.png',
    background: 'linear-gradient(135deg, #00FF7F 0%, #00CED1 100%)',
    url: '/tarot/tarot-nedir',
  },
  {
    title: 'Kartların Anlamları',
    image: '/images/tarot/kartlarin-anlamlari.png',
    background: 'linear-gradient(135deg, #E6E9F0 0%, #1E90FF 100%)',
    url: '/tarot/kartlarin-anlamlari',
  },
  {
    title: 'Günlük Okumalar',
    image: '/images/tarot/gunluk-okumalar.png',
    background: 'linear-gradient(135deg, #FFB6C1 0%, #800080 100%)',
    url: '/tarot/gunluk-okumalar',
  },
];

export const getDailyTarotUrl = () => {
  const monthNames = {
    '01': 'ocak',
    '02': 'subat',
    '03': 'mart',
    '04': 'nisan',
    '05': 'mayis',
    '06': 'haziran',
    '07': 'temmuz',
    '08': 'agustos',
    '09': 'eylul',
    10: 'ekim',
    11: 'kasim',
    12: 'aralik',
  };
  const today = dayjs();
  const day = today.format('D');
  const month = monthNames[today.format('MM')];
  const year = today.format('YYYY');
  return `/astroloji/tarot/${day}-${month}-${year}-gunluk-tarot-fali`;
};

export const tarotTypes = [
  {
    title: 'Günlük Tarot Falı',
    image: '/images/tarot/gunluk-tarot.png',
    url: getDailyTarotUrl(),
    background: 'linear-gradient(180deg, rgba(24, 24, 25, 0.00) 0%, rgba(242, 127, 12, 0.30) 100%), rgba(24, 24, 25, 0.20)',
  },
  // {
  //   title: 'Aşk Tarot Falı',
  //   image: '/images/tarot/ask-tarot.png',
  //   url: '/tarot/ask-tarot-fali',
  //   background: 'linear-gradient(180deg, rgba(24, 24, 25, 0.00) 0%, rgba(247, 37, 133, 0.20) 100%), rgba(24, 24, 25, 0.20)',
  // },
  // {
  //   title: 'Sağlık Tarot Falı',
  //   image: '/images/tarot/saglik-tarot.png',
  //   url: '/tarot/saglik-tarot-fali',
  //   background: 'linear-gradient(180deg, rgba(24, 24, 25, 0.00) 0%, rgba(48, 106, 255, 0.20) 100%), rgba(24, 24, 25, 0.20)',
  // },
  // {
  //   title: 'Para Tarot Falı',
  //   image: '/images/tarot/para-tarot.png',
  //   url: '/tarot/para-tarot-fali',
  //   background: 'linear-gradient(180deg, rgba(24, 24, 25, 0.00) 0%, rgba(66, 188, 108, 0.20) 100%), rgba(24, 24, 25, 0.20)',
  // },
  // {
  //   title: 'Evet/Hayır Tarot Falı',
  //   image: '/images/tarot/evet-hayir-tarot.png',
  //   url: '/tarot/evet-hayir-tarot-fali',
  //   background: 'linear-gradient(180deg, rgba(24, 24, 25, 0.00) 0%, rgba(255, 115, 82, 0.20) 100%), rgba(24, 24, 25, 0.20)',
  // },
  // {
  //   title: 'Flört Tarot Falı',
  //   image: '/images/tarot/flort-tarot.png',
  //   url: '/tarot/flort-tarot-fali',
  //   background: 'linear-gradient(180deg, rgba(24, 24, 25, 0.00) 0%, rgba(179, 159, 211, 0.20) 100%), rgba(24, 24, 25, 0.20)',
  // },
  // {
  //   title: 'Potansiyel Aşk Tarot Falı',
  //   image: '/images/tarot/potansiyel-ask-tarot.png',
  //   url: '/tarot/potansiyel-ask-tarot-fali',
  //   background: 'linear-gradient(180deg, rgba(24, 24, 25, 0.00) 0%, rgba(252, 57, 55, 0.20) 100%), rgba(24, 24, 25, 0.20)',
  // },
];

/**
 * parse tarot url
 * example: /astroloji/tarot/18-mart-2025-gunluk-tarot-fali
 * example: /astroloji/tarot/18-mart-2025-gunluk-tarot-fali/the-fool
 */
export const parseTarotUrl = (url) => {
  const pattern =
    /\/astroloji\/tarot\/(?:(\d{1,2}-[a-zğüşıöç]+-\d{4})-)?(gunluk|ask|saglik|para|evet-hayir|flort|potansiyel-ask)(?:-tarot-fali)?(?:\/([a-z-]+))?/i;
  const match = url.match(pattern);
  if (!match) return null;

  return {
    date: convertTarotDate(match[1]) || null, // date
    type: getTarotType(match[2]) || null, // type
    card: match[3] || null, // card name
    pageType: getTarotPageType(match[3]),
  };
};

// get tarot type
export const getTarotType = (name) => {
  const tarotMap = {
    gunluk: 'daily',
    ask: 'love',
    saglik: 'health',
    para: 'money',
    'evet-hayir': 'yes-no',
    flort: 'flirt',
    'potansiyel-ask': 'potential-love',
  };
  return tarotMap[name] || name;
};

// get tarot page type
const getTarotPageType = (card) => (card ? 'reading' : 'selection');

/**
 * convert tarot date
 * example: 18-mart-2025 to 18.03.2025
 */
export const convertTarotDate = (date) => {
  const months = {
    ocak: '01',
    subat: '02',
    mart: '03',
    nisan: '04',
    mayis: '05',
    haziran: '06',
    temmuz: '07',
    agustos: '08',
    eylul: '09',
    ekim: '10',
    kasim: '11',
    aralik: '12',
  };
  const parts = date.split('-');
  const day = parts[0].padStart(2, '0');
  const month = months[parts[1]] || parts[1];
  const year = parts[2];

  return `${day}.${month}.${year}`;
};

const tarotMap = {
  daily: 'Günlük',
  love: 'Aşk',
  health: 'Sağlık',
  money: 'Para',
  'yes-no': 'Evet/Hayır',
  flirt: 'Flört',
  'potential-love': 'Potansiyel Aşk',
};

/**
 * get tarot title
 * example: 18.03.2025, daily to 18 Mart 2025 Günlük Tarot Falı
 */
export const getTarotTitle = ({ date, type }) => {
  const [day, month, year] = date ? date.split('.') : [];
  const dateText = date ? dayjs(`${year}-${month}-${day}`).format('D MMMM YYYY') : '';
  const typeText = tarotMap[type];
  return `${dateText} ${typeText} Tarot Falı`;
};

export const getTarotDateText = (date) => {
  const [day, month, year] = date ? date.split('.') : [];
  return dayjs(`${year}-${month}-${day}`).format('D MMMM YYYY');
};

export const getTarotMetaTitle = (date, type) => {
  const dateText = getTarotDateText(date);
  const typeText = tarotMap[type];
  return `(${dateText}) ${typeText} Tarot Falı - Onedio`;
};

export const tarotCategoryCards = [
  {
    title: 'Aşk Hikayenizi Keşfedin!',
    description: 'Aşk Tarot açılımınız ile her gün romantik anlamda sizi neyin beklediğini öğrenin.',
    image: '/images/tarot/reading-ask-fali.png',
    url: '/tarot/ask-tarot-fali',
    background: 'linear-gradient(90deg, #4A0001 0%, #8D0002 100%), url("/images/tarot/tarot-ask-bg.png") lightgray 50% / cover no-repeat',
    backgroundBlendMode: 'color-burn',
  },

  {
    title: 'Sağlığınız Hakkında Bilgi Alın!',
    description: 'Sağlık Tarot açılımınız ile her gün sağlığınızla ilgili sizi neyin beklediğini öğrenin.',
    image: '/images/tarot/reading-saglik-fali.png',
    url: '/tarot/saglik-tarot-fali',
    background:
      'linear-gradient(90deg, rgba(0, 12, 41, 0.85) 30%, rgba(0, 38, 136, 0.20) 100%), url("/images/tarot/tarot-saglik-bg.png") lightgray 50% / cover no-repeat',
    backgroundBlendMode: 'multiply, overlay, normal',
  },
  {
    title: 'Finansal Durumunuza Göz Atın!',
    description: 'Para Tarot açılımınız ile her gün finansal durumunuzla ilgili sizi neyin beklediğini öğrenin.',
    image: '/images/tarot/reading-para-fali.png',
    url: '/tarot/para-tarot-fali',
    background: 'linear-gradient(0deg, #2A7F00 0%, #2A7F00 100%), url("/images/tarot/tarot-finans-bg.png")',
    backgroundBlendMode: 'color-burn',
  },
];
